import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface StepIndicatorItem {
  id: number;
  text: string;
}

@Component({
  selector: 'app-step-indicator',
  templateUrl: './step-indicator.component.html',
  styleUrls: ['./step-indicator.component.scss']
})
export class StepIndicatorComponent implements OnChanges {
  @Input() items: StepIndicatorItem[] = [];
  @Input() selected: number | null = null;
  @Input() isComplete: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  get effectiveSelectedId(): number | null {
    if (this.selected !== null && this.selected !== undefined) {
      return this.selected;
    }
    if (this.items && this.items.length > 0) {
      return this.items[0].id;
    }
    return null;
  }

  isCompleted(index: number): boolean {
    if (this.isComplete) return true;

    const selectedId = this.effectiveSelectedId;
    if (selectedId === null) return false;

    // Find index of effective selected item
    const selectedIndex = this.items.findIndex(i => i.id === selectedId);
    if (selectedIndex === -1) return false;

    return index < selectedIndex;
  }

  isActive(index: number): boolean {
    if (this.isComplete) return false;

    const selectedId = this.effectiveSelectedId;
    if (selectedId === null) return false;

    return this.items[index].id === selectedId;
  }
}
